module.exports = __webpack_public_path__ + "static/img/yeswecan0001.184d105.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0001.png
// module id = 567
// module chunks = 1